import { CONSTRUCTION_HOUSES_CDN_PATH } from '../../construction-houses-constants';

export const CONSTRUCTION_HOUSES_PROJECTS_PER_PAGE = 9;

export const CONSTRUCTION_HOUSES_PROJECTS_LIST = [
  'foundation',
  'metal-roof',
  'windows',
  'entrance-doors',
  'engineering-systems',
  'floor-screed',
  'plastering',
  '318',
  '331',
  'ceilings',
  'fences',
];

export const PROJECTS_IMAGES_DATA = [
  {
    serviceId: 'foundation',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/foundation.jpg/foundation.jpg`,
  },
  {
    serviceId: 'metal-roof',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/metal-roof.jpg/metal-roof.jpg`,
  },
  {
    serviceId: 'windows',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/windows.jpg/windows.jpg`,
  },
  {
    serviceId: 'entrance-doors',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/entrance-doors.jpg/entrance-doors.jpg`,
  },
  {
    serviceId: 'engineering-systems',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/engineering-systems.jpg/engineering-systems.jpg`,
  },
  {
    serviceId: 'floor-screed',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/floor-screed.jpg/floor-screed.jpg`,
  },
  {
    serviceId: 'plastering',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/plastering.jpg/plastering.jpg`,
  },
  {
    serviceId: '318',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/318.jpg/318.jpg`,
  },
  {
    serviceId: '331',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/331.jpg/331.jpg`,
  },
  {
    serviceId: 'ceilings',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/ceilings.jpg/ceilings.jpg`,
  },
  {
    serviceId: 'fences',
    imgSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/projects/fences.jpg/fences.jpg`,
  },
];
